export class CortizoUserModel {
    public activatecode: number;
    public area: string;
    public company_name: string;
    public createdAt: string;
    public dni: string;
    public email: string;
    public expirationactivecode: string;
    public expirationdatecode: string;
    public id: number;
    public is_active: boolean;
    public name: string;
    public phone: string;
    public resetcode: string;
    public updatedAt: string;
    public blocked: boolean;
    public roles: { value: string }[];


    constructor(res: any) {
        this.activatecode = res.activatecode || 0;
        this.area = res.area || '';
        this.company_name = res.company_name || '';
        this.createdAt = res.createdAt || '';
        this.dni = res.dni || '';
        this.email = res.email || '';
        this.expirationactivecode = res.expirationactivecode || '';
        this.expirationdatecode = res.expirationdatecode || '';
        this.id = res.id || null;
        this.is_active = Boolean(res.is_active);
        this.name = res.name || '';
        this.phone = res.phone || '';
        this.resetcode = res.resetcode || '';
        this.updatedAt = res.updatedAt || '';

        this.blocked = res.blocked || false;
        this.roles = res.roles || [];
    }
}
